export async function getTVLData() {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/protocol/metrics/tvl`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        )
        return await response.json()
    } catch (err) {
        console.log("Request failed")
    }
}
